module.exports = __webpack_public_path__ + "img/00—02—Password recovery—IBplus.01645ff2.jpg";